<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  fieldName: {
    type: String,
    required: true
  }
})

const rowItem = computed({
  get() {
    return props.item
  },
  set() {
    return null
  }
})

const emit = defineEmits<{
  (e: 'resetValue', fieldName: string): void
  (e: 'change', value: string): void
}>()
</script>

<template>
  <v-text-field
    v-model="rowItem[fieldName]"
    type="number"
    class="field-input"
    prepend-inner-icon="mdi-refresh"
    hide-details
    density="compact"
    variant="plain"
    center
    @click:prepend-inner="emit('resetValue', fieldName)"
    @change="emit('change', $event.target.value)"
  >
  </v-text-field>
</template>

<style scoped>
.field-input {
  min-width: 60px;
}

.field-input :deep(.v-field__append-inner),
:deep(.v-field__prepend-inner) {
  padding: 3px 6px 0 0;
}

.field-input :deep(.v-field__input) {
  font-size: 14px;
  text-align: center;
  padding: 0;
}
</style>
